import {SvgIcon} from "@material-ui/core";

export const CustomMarketListIcon = (props) => {
    return (
        <SvgIcon width="20" height="21" viewBox="0 0 20 21" fill="#CDBDDB" {...props}>
            <path d="M3.33366 5.54134H1.66699V17.208C1.66699 18.1247 2.41699 18.8747 3.33366 18.8747H15.0003V17.208H3.33366V5.54134ZM16.667 2.20801H6.66699C5.75033 2.20801 5.00033 2.95801 5.00033 3.87467V13.8747C5.00033 14.7913 5.75033 15.5413 6.66699 15.5413H16.667C17.5837 15.5413 18.3337 14.7913 18.3337 13.8747V3.87467C18.3337 2.95801 17.5837 2.20801 16.667 2.20801ZM15.8337 9.70801H7.50033V8.04134H15.8337V9.70801ZM12.5003 13.0413H7.50033V11.3747H12.5003V13.0413ZM15.8337 6.37467H7.50033V4.70801H15.8337V6.37467Z"/>
        </SvgIcon>
    )
}
